<template>
  <el-container class="setting-page">
    <!-- 左侧导航 -->
    <el-aside width="230px" class="setting-aside" :class="{ fullscreen: configStore.fullScreen }">
      <div class="nav-menu" >
        <div v-for="(item, index) in visibleMenuItems" :key="index" class="nav-item"
          :class="{ active: currentTab === index }" @click="switchTab(index)">
          <i :class="item.icon"></i>
          <span>{{ item.label }}</span>
        </div>
      </div>
    </el-aside>

    <!-- 右侧内容区域 -->
    <el-container class="setting-main">
      <div class="content-wrapper" :class="configStore.electronMode ? 'header-menu-wrap' : ''">
        <!-- 个人资料 -->
        <div v-show="currentTab === 0" class="tab-content">
          <personal-info ref="personalInfo" @switch-tab="onSwitchTab"></personal-info>
        </div>

        <!-- 用户设置 -->
        <div v-show="currentTab === 1" class="tab-content">
          <user-config ref="userConfig"></user-config>
        </div>

        <!-- 绑定手机 -->
        <div v-show="currentTab === 2" class="tab-content">
          <bind-phone ref="bindPhone"></bind-phone>
        </div>

        <!-- 绑定邮箱 -->
        <div v-show="currentTab === 3" class="tab-content">
          <bind-email ref="bindEmail"></bind-email>
        </div>

        <!-- 修改密码 -->
        <div v-show="currentTab === 4" class="tab-content">
          <modify-password ref="modifyPassword"></modify-password>
        </div>

        <!-- 实名认证 -->
        <div v-show="currentTab === 5" class="tab-content">
          <realname-auth ref="realnameAuth"></realname-auth>
        </div>

        <!-- 朋友圈 -->
        <div v-show="currentTab === 6" class="tab-content">
          <moments ref="moments"></moments>
        </div>

        <!-- 关于我们 -->
        <div v-show="currentTab === 7" class="tab-content" v-if="configStore.electronMode">
          <about-us ref="aboutUs"></about-us>
        </div>
      </div>
    </el-container>
  </el-container>
</template>

<script>
import ModifyPassword from '../components/setting/ModifyPassword.vue';
import PersonalInfo from '../components/setting/PersonalInfo.vue';
import UserConfig from '../components/setting/UserConfig.vue';
import BindPhone from '../components/setting/BindPhone.vue';
import BindEmail from '../components/setting/BindEmail.vue';
import RealnameAuth from '../components/setting/RealnameAuth.vue';
import AboutUs from '../components/setting/AboutUs.vue';
import Moments from '../components/setting/Moments.vue';

export default {
  name: "SettingPage",
  components: {
    PersonalInfo,
    UserConfig,
    BindPhone,
    BindEmail,
    ModifyPassword,
    RealnameAuth,
    AboutUs,
    Moments
  },
  data() {
    return {
      currentTab: 0
    }
  },
  computed: {
    menuItems() {
      const items = [
        {
          label: '个人资料',
          icon: 'el-icon-user',
          component: 'personalInfo'
        },
        {
          label: '用户设置',
          icon: 'el-icon-setting',
          component: 'userConfig'
        },
        {
          label: '绑定手机',
          icon: 'el-icon-mobile-phone',
          component: 'bindPhone'
        },
        {
          label: '绑定邮箱',
          icon: 'el-icon-message',
          component: 'bindEmail'
        },
        {
          label: '修改密码',
          icon: 'el-icon-lock',
          component: 'modifyPassword'
        },
        {
          label: '实名认证',
          icon: 'el-icon-postcard',
          component: 'realnameAuth'
        },
        {
          label: '朋友圈',
          icon: 'el-icon-picture-outline',
          component: 'moments'
        }
      ];

      // 仅在 Electron 模式下显示"关于我们"
      if (this.configStore.electronMode) {
        items.push({
          label: '关于我们',
          icon: 'el-icon-info',
          component: 'aboutUs'
        });
      }

      return items;
    },
    visibleMenuItems() {
      return this.menuItems.filter(item => !item.show || item.show());
    }
  },
  mounted() {
    this.init();
    // 监听来自UserProfileCard的切换事件
    this.$eventBus.$on('switchToPersonalInfo', () => {
      this.switchTab(0); // 切换到个人资料tab (index 0)
    });
  },
  methods: {
    init() {
      // 根据路由参数设置当前tab
      const tab = this.$route.query.tab;
      if (tab) {
        this.currentTab = parseInt(tab);
      }
      this.$nextTick(() => this.onClickTab());
    },
    switchTab(index) {
      this.currentTab = index;
      this.$nextTick(() => this.onClickTab());
    },
    onClickTab() {
      const componentMap = {
        0: 'personalInfo',
        1: 'userConfig',
        2: 'bindPhone',
        3: 'bindEmail',
        4: 'modifyPassword',
        5: 'realnameAuth',
        6: 'moments',
        7: 'aboutUs'
      };

      const componentName = componentMap[this.currentTab];
      if (componentName && this.$refs[componentName] && this.$refs[componentName].init) {
        this.$refs[componentName].init();
      }
    },
    onSwitchTab(tabIndex) {
      this.currentTab = parseInt(tabIndex);
      this.$nextTick(() => this.onClickTab());
    }
  },
  beforeDestroy() {
    // 移除事件监听，避免内存泄漏
    this.$eventBus.$off('switchToPersonalInfo');
  }
}
</script>

<style lang="scss" scoped>
.setting-page {
  height: 100vh;
  background: transparent; // 透出 dawn 底纸

  .setting-aside {
    display: flex;
    flex-direction: column;
    border-right: 0.5px solid var(--hairline-soft);
    background:
      linear-gradient(180deg, rgba(255, 252, 243, 0.55), rgba(255, 252, 243, 0.45));
    backdrop-filter: blur(20px) saturate(140%);
    -webkit-backdrop-filter: blur(20px) saturate(140%);

    &.fullscreen {
      width: 260px !important;
      @media (min-width: 1200px) { width: 290px !important; }
    }

    .nav-menu {
      padding: 12px 8px;

      .nav-item {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 14px;
        margin: 2px 0;
        cursor: pointer;
        transition: all 0.18s cubic-bezier(0.32, 0.72, 0, 1);
        color: var(--im-text-color-secondary);
        font-weight: 500;
        letter-spacing: -0.2px;
        border: 0.5px solid transparent;
        border-radius: var(--radius-md);
        position: relative;

        &:hover {
          background: rgba(91, 141, 238, 0.08);
          color: var(--aurora-blue);
        }

        &.active {
          background:
            linear-gradient(135deg, rgba(91, 141, 238, 0.16), rgba(168, 139, 255, 0.12) 60%, rgba(255, 175, 204, 0.08));
          color: var(--aurora-blue);
          border-color: rgba(91, 141, 238, 0.30);
          font-weight: 600;
          box-shadow:
            inset 0 1px 0 0 rgba(255, 255, 255, 0.85),
            0 4px 10px rgba(91, 141, 238, 0.14);

          &::before {
            content: '';
            position: absolute;
            left: -3px; top: 50%; transform: translateY(-50%);
            width: 3px; height: 22px;
            border-radius: 2px;
            background: linear-gradient(180deg, var(--aurora-blue), var(--aurora-purple));
          }
        }

        i { font-size: 18px; width: 20px; text-align: center; }
        span { font-size: 14px; }
      }
    }
  }

  .setting-main {
    background: transparent;
    overflow: hidden;

    .content-wrapper {
      height: 100%;
      overflow-y: auto;
      width: 100%;

      .tab-content {
        height: 100%;
        overflow-y: auto;
        padding: 0;
      }
    }
  }
}
</style>
